import {Button} from "antd";
import './customButton.scss'

const CustomButton = ({type='primary',ghost,text,width='150px',style,onClick})=>{

    return (
        <Button
            type={type}
            ghost={ghost}
            className={'custom-button'}
            style={{...style, width: `${width}px`}}
            onClick={onClick}
            size={'large'}
        >
            {text}
        </Button>
    )
}

export default CustomButton